<script src="https://www.google.com/recaptcha/api.js" async defer></script>
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Newsletter',

    metaInfo: { title: 'Newsletter' },

    extends: View,

    mixins: [
      LoadSections([
        'newsletter',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'newsletter',
      },
    },
  }
</script>
<style>
#recaptcha-container > * { margin: auto; }
</style>
